import {createSelector} from 'reselect';

import ModalTypes from '@/consts/app/modalTypes';

const selectLoyalty = (state) => state.loyalty;

const selectLoyaltyPopups = createSelector(selectLoyalty, (state) => state.popups);

const selectIsJourneyBadgePending = createSelector(selectLoyaltyPopups, (state) => {
    return state[ModalTypes.EARN_BADGE]?.state?.isPending;
});

const selectIsJourneyLevelTaskPending = createSelector(selectLoyaltyPopups, (state) => {
    return state[ModalTypes.COMPLETE_JOURNEY_LEVEL_TASK]?.state?.isPending;
});

const selectIsLoyaltyPending = createSelector(
    [selectIsJourneyBadgePending, selectIsJourneyLevelTaskPending],
    (isBadgePending, isLevelTaskPending) => {
        return isBadgePending || isLevelTaskPending;
    }
);

export {
    selectIsJourneyBadgePending,
    selectIsJourneyLevelTaskPending,
    selectIsLoyaltyPending,
    selectLoyalty,
    selectLoyaltyPopups,
};
